<template>
  <router-view />
</template>

<script>
export default {
  name: "gantt",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
